<template>
  <div class="card">
    <div class="card-content">
      <b-table :data="listBeds" :narrowed="true" :hoverable="true" :loading="isLoading" paginated per-page="10">
        <b-table-column field="n_cama" label="#" v-slot="props">
          {{props.row.id}}
        </b-table-column>
        <b-table-column field="n_cama" label="N° de Cama" v-slot="props" searchable>
          Cama {{ props.row.n_cama }}
        </b-table-column>
        <b-table-column field="state" label="Estado de la cama" v-slot="props">
          <b-tooltip :label="props.row.patient_id ? 'Con paciente' : 'Sin paciente'" type="is-dark" >
            <!-- <span @click="openModalDataPatient(props.row)"> -->
              <b-icon icon="user" :type="props.row.patient_id ? 'is-dark' : ''" style="color: #dededef7"> </b-icon>
            <!-- </span> -->
          </b-tooltip>
          <b-tooltip :label="props.row.covid19 == 'positivo' ? 'Con covid' : 'Sin covid'" type="is-dark">
            <b-icon icon="virus" :type="props.row.covid19 == 'positivo' ? 'is-dark' : ''" style="color: #dededef7"> </b-icon>
          </b-tooltip>
          <b-tooltip v-if="props.row.ventilator == 'si'" :label="props.row.ventilator_used == 'si' ? 'Ventilador ocupado' : 'Ventilador libre'" type="is-dark">
            <b-icon icon="fan" :style="props.row.ventilator_used == 'si' ? 'color: #cc0f35bf;' : 'color: #409a5e'"> </b-icon>
          </b-tooltip>
          <b-tooltip v-else label="Cama sin ventilador" type="is-dark">
            <b-icon icon="fan"  style="color: #dededef7"> </b-icon>
          </b-tooltip>
          <b-tag type="is-success is-light" v-if="props.row.state == 'HABILITADA'">{{ props.row.state }}</b-tag>
          <b-tag type="is-danger is-light" v-else-if="props.row.state == 'BLOQUEADA'">{{ props.row.state }}</b-tag>
        </b-table-column>
        <b-table-column field="Action" label="Acciones" v-slot="props">
          <b-field grouped>
            <p class="control">
                <button-unassign-patient :bed="props.row" v-if="props.row.patient_id!==null"></button-unassign-patient>                
                <button-assign-patient v-else :bed="props.row"></button-assign-patient>                
            </p>            
            <p class="control">
                <button-change-state-bed :bed="props.row"></button-change-state-bed>                
            </p>
            <p class="control">
                <button-edit-bed :bed="props.row" :changeVentilator="!props.row.patient_id"></button-edit-bed>                
            </p>
            <p class="control">
              <b-tooltip label="Historial de cambios" type="is-dark">
                <b-button type="is-primary" size="is-small" @click="openModalBedHIstory(props.row.id)" icon-left="clock"></b-button>
              </b-tooltip>
            </p>
          </b-field>
        </b-table-column>
        <template slot="empty">
          <section class="section">
            <div class="content has-text-grey has-text-centered">
              <p>
                <b-icon icon="frown-open" size="is-large"></b-icon>
              </p>
              <p>No hay camas en el listado actual</p>
            </div>
          </section>
        </template>
      </b-table>
    </div>
  </div>
</template>
<script>
  import ButtonAssignPatient from "./ButtonAssignPatient.vue";
  import ButtonChangeStateBed from "./ButtonChangeStateBed.vue";
  import { eventBus } from "../../main";
  import ButtonEditBed from "./ButtonEditBed.vue";
  import ButtonUnassignPatient from "./ButtonUnassignPatient.vue";
  import ModalBedHistory from "./ModalBedHistory";
  // import ModalShowPatient from "./ModalShowPatient";

  export default {
    props: ["listBeds"],
    components: {
      ButtonAssignPatient,
      ButtonChangeStateBed,
      ButtonEditBed,
      ButtonUnassignPatient,
    },
    data() {
      return {
        isLoading: false,
      };
    },
    mounted() {
      eventBus.$on("rechargeTableBed", (event) => {
        this.isLoading = event == true ? true : false;
      });
    },
    methods:{
      openModalBedHIstory(bedId){
        this.$buefy.modal.open({
          parent: this,
          component: ModalBedHistory,
          props: {
            bedId: bedId,
          },
          hasModalCard: true,
          trapFocus: true,
        });
      }
    }
  };
</script>